/* eslint-disable */
import { useMemo } from 'react';
import useSWR, { mutate } from 'swr';
import axios, { endpoints, fetcher } from '../utils/axios';
import { USER_ID } from 'src/config-global';

export function useGetLfCalculators({ id }) {
  const URL = id ? endpoints.calculator.list(id) : null;
  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
    errorRetryCount: 0,
    errorRetryInterval: 0,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      lfCalculators: response || [],
      lfCalculatorsLoading: isLoading,
      lfCalculatorsError: error,
      lfCalculatorsValidating: isValidating,
      lfCalculatorsEmpty: !isLoading && !response?.length,
    }),
    [response, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function addLfCalculator(id, apiData) {
  const URL = id ? endpoints.calculator.create(id) : null;
  const URL2 = endpoints.appointment.list;

  try {
    const { data } = await axios.post(URL, apiData);
    await mutate(URL2);
    return data;
  } catch (error) {
    console.error('Error addingLfCalculator:', error);
    throw error;
  }
}

export function useGetAppointmentsCalculators(id) {
  const URL = id ? endpoints.calculator.list(id, USER_ID) : null;
  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
    errorRetryCount: 0,
    errorRetryInterval: 0,
  });

  const memoizedValue = useMemo(
    () => ({
      appointmentsCalculators: data?.data || [],
      appointmentsCalculatorsLoading: isLoading,
      appointmentsCalculatorsError: error,
      appointmentsCalculatorsValidating: isValidating,
      appointmentsCalculatorsEmpty: !isLoading && !data?.data?.length,
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function updateLfCalculator(appointmentId, id, apiData) {
  const URL = id ? endpoints.calculator.update(id) : null;
  const URL2 = appointmentId ? endpoints.calculator.list(appointmentId, USER_ID) : null;

  try {
    const { data } = await axios.put(URL, apiData);
    await mutate(URL2);
    return data;
  } catch (error) {
    console.error('Error updatingLfCalculator:', error);
    throw error;
  }
}

export async function deleteLFCalculator(appointmentId, id) {
  const URL = id ? endpoints.calculator.delete(id) : null;

  try {
    const { data } = await axios.delete(URL, { data: { userId: USER_ID } });
    await mutate(endpoints.calculator.list(appointmentId, USER_ID));
    return data;
  } catch (error) {
    console.error('Error deletingLfCalculator:', error);
    throw error;
  }
}

export async function updateLfCalculatorPositions(appointmentId, apiData) {
  const URL = endpoints.calculator.arrange;
  const URL2 = appointmentId ? endpoints.calculator.list(appointmentId, USER_ID) : null;

  try {
    const { data } = await axios.put(URL, apiData);
    await mutate(URL2);
    return data;
  } catch (error) {
    console.error('Error updatingLfCalculatorPositions:', error);
    throw error;
  }
}
